import * as React from 'react';
import { IconMap } from './IconMap';
import { validateSize } from './iconUtils';
const Icon = (props) => {
    const { name, size = 'md', color, className, style, onClick = () => { }, onMouseOver = () => { }, onMouseLeave = () => { }, ...rest } = props;
    let icon = name;
    if (!IconMap[name]) {
        // throw new Error(`Icon named "${name}" not found.`);
        icon = 'octagon-exclamation';
        console.error(`Icon named "${name}" not found. Using "${icon}" as fallback.`);
    }
    const IconComponent = IconMap[icon];
    let sizePixels = validateSize(size);
    return (React.createElement(IconComponent, { name: icon, title: icon, className: className, onClick: onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, fill: color ? color : 'currentColor', width: sizePixels, height: sizePixels, ...rest }));
};
export default Icon;
